import React, { memo, useEffect, useState } from "react";
import {
  TabContext,
  TabList,
  Box,
  Tab,
  TabPanel,
  Stack,
  Switch,
  FormControlLabel,
  Typography,
} from "investira.react.components";
import { validators } from "investira.sdk";
import { useConsultaContext } from "../../../../contexts/ConsultaContext";
import { ATIVO_MERCADO, ATIVO_TIPO } from "@investirapri/financa.js/lib/enums";
import Detalhes from "./Detalhes";

const Secoes = memo((props) => {
  const { data } = props;

  const { state, actions } = useConsultaContext();

  const [value, setValue] = useState(null);
  const [secoes, setSecoes] = useState({});

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  function groupByMercado(pDetalhe) {
    if (!Array.isArray(pDetalhe)) {
      console.warn("O parâmetro deve ser um array.");
      return {};
    }

    return pDetalhe.reduce((acc, item) => {
      const mercado = item.mercado || "NIDX";
      if (!acc[mercado]) {
        acc[mercado] = [];
      }
      acc[mercado].push(item);
      return acc;
    }, {});
  }

  useEffect(() => {
    if (!validators.isNull(data.response?.detalhe)) {
      const xDetalhe = data.response.detalhe;

      if (state.orderBy) {
        xDetalhe.sort((a, b) => {
          const isinA = a.isin || a.cnpj || "";
          const isinB = b.isin || b.cnpj || "";
          return isinA.localeCompare(isinB);
        });
      }

      const xGroupedByMercado = groupByMercado(xDetalhe);

      setSecoes(xGroupedByMercado);
      const xKeys = Object.keys(xGroupedByMercado).sort();
      setValue(xKeys[0]);
    }
  }, [data.response, state.orderBy]);

  if (validators.isNull(data.response) || validators.isNull(value)) {
    return null;
  }

  return (
    <TabContext value={value}>
      <Box
        sx={
          {
            // borderBottom: 1,
            // borderColor: "divider"
          }
        }
      >
        <TabList
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="Seções"
        >
          {Object.keys(secoes)
            .sort()
            .map((xKey) => {
              return (
                <Tab
                  key={`tab-${xKey}`}
                  label={
                    xKey === "NIDX"
                      ? "Não Identificados"
                      : ATIVO_MERCADO[xKey].descricao
                  }
                  value={xKey}
                />
              );
            })}
        </TabList>
      </Box>

      {Object.entries(secoes)
        .sort()
        .map(([xKey, xValue]) => {
          const xDetalhe = Array.isArray(xValue)
            ? [...xValue].sort((a, b) => {
                if (a.ativo < b.ativo) return -1;
                if (a.ativo > b.ativo) return 1;
                return 0;
              })
            : xValue;
          return (
            <TabPanel
              value={xKey}
              sx={{ px: 0, pt: 0, marginTop: "0px !important" }}
            >
              <Detalhes detalhe={xDetalhe} />
            </TabPanel>
          );
        })}
    </TabContext>
  );
});

export default Secoes;
